<app-layout>
    <!-- components title start -->
    <div class="components-title">
        <h2>{{ launchpad.name }}</h2>
    </div>
    <!-- components title end -->


    <!-- launchpad inner start -->
    <div class="launchpad-inner">

        <div class="launchpad-inner__progressbar">
            <div class="progressbar-value">
                <div class="progressbar-a">{{ launchpad.raised_amount }} {{ launchpad.network_symbol }}</div>
                <div class="progressbar-b">{{ launchpad.hard_cap }} {{ launchpad.network_symbol }}</div>
            </div>
            <progress-bar bar-color="#4dd457" class="progressbars" size="medium" :val="launchpad.filled" :text="launchpad.filled + '%'" :title="launchpad.filled + '%'" />
            <div class="progressbar-title">{{ $t('Description:') }}</div>
            <p class="progressbar-text" v-html="launchpad.description"></p>
        </div>

        <div class="launchpad-options">
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Coin') }}</span>
                <span class="launchpad-options__value">{{ launchpad.currency }}</span>
            </div>
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Symbol') }}</span>
                <span class="launchpad-options__value">{{ launchpad.currency_symbol }}</span>
            </div>
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Network') }}</span>
                <span class="launchpad-options__value">{{ launchpad.network }}</span>
            </div>
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Minimum buy amount') }}</span>
                <span class="launchpad-options__value">{{ launchpad.min_buy }} {{ launchpad.network_symbol }}</span>
            </div>
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Maximum buy amount') }}</span>
                <span class="launchpad-options__value">{{ launchpad.max_buy }} {{ launchpad.network_symbol }}</span>
            </div>
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Soft Cap.') }}</span>
                <span class="launchpad-options__value">{{ launchpad.soft_cap }} {{ launchpad.network_symbol }}</span>
            </div>
            <div class="launchpad-options__item">
                <span class="launchpad-options__title">{{ $t('Hard Cap.') }}</span>
                <span class="launchpad-options__value">{{ launchpad.hard_cap }} {{ launchpad.network_symbol }}</span>
            </div>
        </div>

        

        <div class="flex">
            <span class="title-font font-medium text-xl ">{{ $t('Sale Price:') }} {{ launchpad.rate }} {{ launchpad.network_symbol }}</span>
            <button @click="state = !state" v-if="$page.props.user && !state" class="flex ml-auto text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded">{{ $t('Buy') }} {{ launchpad.currency_symbol }}</button>
            <button @click="login" v-if="!$page.props.user" class="flex ml-auto text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded">{{ $t('Login to invest') }}</button>
        </div>

        <div class="components-filter components-filter__form" v-if="state">
            <form>
                <div class="components-filter__row">
                    <div class="components-filter__item">
                        <label for="text-input-36" class="form-label">{{ $t('Amount in') }} {{ launchpad.network_symbol }}:</label>
                        <input @keyup="(e) => clearInput(e)" @keypress="(e) => handleInput(e)" @paste.prevent @drop.prevent placeholder="0.00" v-model="form.amount" id="text-input-36" type="text" class="border-gray-200 focus:border-gray-300 focus:ring focus:ring-gray-200 focus:ring-opacity-10 rounded mt-2 block w-full">
                    </div>
                </div>
                <div class="components-filter__row">
                    <div class="components-filter__item">
                        <button @click.prevent="submit" v-if="$page.props.user" class="flex text-white bg-indigo-500 border-0 py-2 px-6 focus:outline-none hover:bg-indigo-600 rounded">
                            <span class="components-filter__icon">
                                <svg v-show="sending" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                {{ $t('Buy') }} {{ launchpad.currency_symbol }}
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <!-- launchpad inner end -->




    <!-- form search end -->
</app-layout>
